import { Component } from '@angular/core';

@Component({
  selector: 'app-template-name',
  templateUrl: './template-name.component.html',
  styleUrls: ['./template-name.component.scss'],
  standalone: false
})
export class TemplateNameComponent {}
